module.exports = __webpack_public_path__ + "static/img/5.c00d929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/5.png
// module id = we5+
// module chunks = 0